import { render, staticRenderFns } from "./CustomAddForm.vue?vue&type=template&id=bd761f42&scoped=true"
import script from "./CustomAddForm.vue?vue&type=script&lang=js"
export * from "./CustomAddForm.vue?vue&type=script&lang=js"
import style0 from "./CustomAddForm.vue?vue&type=style&index=0&id=bd761f42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd761f42",
  null
  
)

export default component.exports